import { Button } from '@/components/shadcn/button'
import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { ApplicationForm } from '../Forms/ApplicationForm'
import { columns } from './ApplicationsTableV2/applicationTableColumns'
import { GridTableToggle } from './GridTableToggle'
import { useOutletContext } from 'react-router'
import { ApplicationsOutletContext } from '@/layouts/ApplicationsRootLayout'

export function ApplicationsTable() {
  const { view, setView } = useOutletContext<ApplicationsOutletContext>()
  const { getApplicationsApiGetApplications } = useRestClient()
  const { data: applications } = getApplicationsApiGetApplications.useSuspenseQuery(undefined)
  return (
    <DataTable
      title="Applications"
      columns={columns}
      data={applications}
      action={
        <div className="flex items-center gap-x-2">
          <ApplicationForm
            sheetTitle="Add Application"
            sheetTrigger={
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add Application
              </Button>
            }
          />
          <GridTableToggle value={view} onChange={setView} />
        </div>
      }
    />
  )
}
